module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-content-between mt-1"
  }, [(_vm.showEditBtn) ? _c('router-link', {
    staticClass: "btn tertiary flex-all fs-smaller",
    attrs: {
      "to": {
        name: 'calendarExpandedWithEventIdEdit',
        params: {
          currentView: 'day',
          expandedDay: (_vm.event.start ? _vm.event.start.substring(0, 10) : ''),
          eventID: _vm.event.id
        }
      },
      "role": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openModifiedEditEvent.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Edit\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showReservationsBtn) ? _c('router-link', {
    staticClass: "btn tertiary flex-all mx-1 fs-smaller",
    attrs: {
      "to": {
        name: 'reservationsByEventId',
        params: {
          eventId: _vm.event.id
        }
      },
      "role": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openModifiedReservations.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Reservations\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showCanceledBtn) ? _c('button', {
    staticClass: "btn bg-color-6 lightest tertiary flex-all fs-smaller",
    on: {
      "click": _vm.showCanceledPopup
    }
  }, [_vm._v("\n        Canceled\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showBookingBtn) ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.bookButtonLook.reasons),
      expression: "bookButtonLook.reasons"
    }],
    staticClass: "btn flex-all fs-smaller",
    class: _vm.bookButtonLook.classes,
    on: {
      "click": _vm.bookButtonPress
    }
  }, [_vm._v("\n      " + _vm._s(_vm.bookButtonLook.label) + "\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0ae11c1e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae11c1e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/Links.vue
// module id = 2722
// module chunks = 0